// extracted by mini-css-extract-plugin
export default {"root":"Content-root__ddWU"};